module.exports = __webpack_public_path__ + "img/zw_banner3.24fb8ea9.png";